import React, { useState, useEffect } from "react";
import API_URL from "../config";
import { useGlobal } from "../context/ContenedorGlobal";
import "../styles/Formularios.css";
import Hardware from "./Hardware";
import InputGenerico from "./InputGenerico";
import { useApiFetch } from "../utils/apiFetch";

function EliminarUsuarios({ idUsuarioSeleccionado }) {

    const { setSubModuloActual, logout } = useGlobal();
    const [idUsuario, setIdUsuario] = useState(idUsuarioSeleccionado || "");
    const [datosUsuario, setDatosUsuario] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [mostrarHardware, setMostrarHardware] = useState(false);
    const apiFetch = useApiFetch();

    // idUsuarioSeleccionado si viene un desde ConsultarUsuarios.jsx, cargar datos directamente
    useEffect(() => {
        if (idUsuarioSeleccionado) {
            consultarUsuario(idUsuarioSeleccionado);
        }
    }, [idUsuarioSeleccionado]);

    // Efecto secundario para consultar al usuario seleccionado
    const consultarUsuario = async (id) => {

        setError("");
        setSuccess("");
        setLoading(true);

        try {

            const data = await apiFetch("consultar_usuario_especifico.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_usuario: id })
            }, logout);

            if (data.status === "ok" && data.usuario) {
                setDatosUsuario(data.usuario);
            } else {
                setError(data.message || "Usuario no encontrado.");
            }
        } catch {
            setError("Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    // Buscar usuario manualmente, directo de este componente
    const handleBuscar = async (e) => {
        e.preventDefault();
        if (!idUsuario.trim()) {
            setError("Debe ingresar el número de empleado.");
            return;
        }
        consultarUsuario(idUsuario);
    };

    // Eliminar usuario
    const handleEliminar = async () => {
        setError("");
        setSuccess("");
        setLoading(true);

        try {

            const data = await apiFetch("eliminar_usuarios.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_usuario: idUsuario })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Usuario eliminado correctamente.");
            } else {
                setError(data.message || "Error al eliminar usuario.");
            }

            // Actualizar estados en cualquiera de los dos casos
            setTimeout(() => {
                setMostrarHardware(true);
                setSubModuloActual(null);
                setLoading(false);
            }, 3000);

        } catch {
            setError("Error de conexión con el servidor.");
            setTimeout(() => {
                setMostrarHardware(true);
                setSubModuloActual(null);
                setLoading(false);
            }, 3000);
        }
    };

    // Función para cancelar la última acción de eliminar
    const handleCancelar = () => {
        setDatosUsuario(null);
        setIdUsuario("");
        setError("");
        setSuccess("");
        setMostrarHardware(true);
        setSubModuloActual(null);
    };

    if (mostrarHardware) {
        return <Hardware />;
    }


    return (
        <div className="sesion-form">
            {/* Buscar usuario directamente desde este componente */}
            {!idUsuarioSeleccionado && !datosUsuario && (
                <form onSubmit={handleBuscar}>

                    <InputGenerico
                        value={idUsuario}
                        setValue={setIdUsuario}
                        label="Número de empleado"
                        maxLength={7}
                        allowedChars="0-9"
                        placeholder="7120000"
                        title="Debe contener exactamente 7 dígitos numéricos"
                    />

                    {error && <div className="error">{error}</div>}
                    {success && <div className="success">{success}</div>}

                    <div className="form-buttons">
                        <button type="submit" disabled={loading}>
                            {loading ? "Buscando..." : "Buscar"}
                        </button>
                    </div>
                </form>
            )}

            {/* Mostrar el usuario antes de eliminar */}
            {datosUsuario && (
                <div>
                    <p>
                        ¿Seguro que deseas eliminar al usuario <strong>{datosUsuario.usuario}</strong> con No. Empleado: <strong>{datosUsuario.id_usuario}</strong>?
                    </p>

                    {error && <div className="error">{error}</div>}
                    {success && <div className="success">{success}</div>}

                    <div className="form-buttons">
                        <button onClick={handleEliminar} disabled={loading}>
                            {loading ? "Eliminando..." : "Eliminar"}
                        </button>
                        <button onClick={handleCancelar}>
                            Cancelar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default EliminarUsuarios;